/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Meta_TitleInputs */

const en_pb_meta_title = /** @type {(inputs: Pb_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbooks — Bystep`)
};

const id_pb_meta_title = /** @type {(inputs: Pb_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbook — Bystep`)
};

/**
* | output |
* | --- |
* | "Playbooks — Bystep" |
*
* @param {Pb_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_meta_title = /** @type {((inputs?: Pb_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_meta_title(inputs)
	return en_pb_meta_title(inputs)
});